module.exports = __webpack_public_path__ + "static/media/marker.b924e4b6.svg";